import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { TaskBoardRequest } from '@services/associations/model/taskBoardRequest';
import { TaskChangeStatusRequest } from '@services/associations/model/taskChangeStatusRequest';
import { TaskRequest } from '@services/associations/model/taskRequest';
import { TaskResponse } from '@services/associations/model/taskResponse';
import {TaskBoardFilter} from '@crm/components/leads/models/TaskModels';

export enum LeadsBoardActionTypes {
  UploadLeads = '[LeadsBoard] Upload Leads',
  UploadLeadsSuccess = '[LeadsBoard] Upload Leads Success',
  UploadLeadsFailure = '[LeadsBoard] Upload Leads Failure',
  LoadTasks = '[LeadsBoard] Load Tasks',
  LoadTasksSuccess = '[LeadsBoard] Load Tasks Success',
  LoadTasksFailure = '[LeadsBoard] Load Tasks Failure',
  AddTasks = '[LeadsBoard] Add Tasks',
  AddTasksSuccess = '[LeadsBoard] Add Tasks Success',
  AddTasksFailure = '[LeadsBoard] Add Tasks Failure',
  EditTasks = '[LeadsBoard] Edit Tasks',
  EditTasksSuccess = '[LeadsBoard] Edit Tasks Success',
  EditTasksFailure = '[LeadsBoard] Edit Tasks Failure',
  EditMultipleTasks = '[LeadsBoard] Edit Multiple Tasks',
  ChangeTaskStatus = '[LeadsBoard] Change Task',
  ChangeTaskStatusSuccess = '[LeadsBoard] Change Task Success',
  ChangeTaskStatusFailure = '[LeadsBoard] Change Task Failure',
  ChangeTaskStatusCanceled = '[LeadsBoard] Change Task Canceled',
  DeleteTasksSuccess = '[LeadsBoard] Delete Tasks Success',
  SetFilter = '[LeadsBoard] Set Filter',
  UpdateFilter = '[LeadsBoard] Update Filter',
  ClearFilter = '[LeadsBoard] Clear Filter',
  SetInitialState = '[LeadsBoard] Set Initial State',
}

/** Upload Leads */
export class UploadLeads implements Action {
  readonly type = LeadsBoardActionTypes.UploadLeads;
  constructor() {}
}

export class UploadLeadsSuccess implements Action {
  readonly type = LeadsBoardActionTypes.UploadLeadsSuccess;
  constructor() {}
}

export class UploadLeadsFailure implements Action {
  readonly type = LeadsBoardActionTypes.UploadLeadsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Load Tasks */
export class LoadTasks implements Action {
  readonly type = LeadsBoardActionTypes.LoadTasks;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadTasksSuccess implements Action {
  readonly type = LeadsBoardActionTypes.LoadTasksSuccess;
  constructor(public payload: TaskResponse[]) { }
}

export class LoadTasksFailure implements Action {
  readonly type = LeadsBoardActionTypes.LoadTasksFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Tasks */
export class AddTasks implements Action {
  readonly type = LeadsBoardActionTypes.AddTasks;
  constructor(public payload: TaskRequest) {}
}

export class AddTasksSuccess implements Action {
  readonly type = LeadsBoardActionTypes.AddTasksSuccess;
  constructor(public payload: TaskResponse, public isSocket?: boolean) { }
}

export class AddTasksFailure implements Action {
  readonly type = LeadsBoardActionTypes.AddTasksFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Tasks */
export class EditTasks implements Action {
  readonly type = LeadsBoardActionTypes.EditTasks;
  constructor(public payload: {taskId: string, request: TaskRequest}) {}
}

export class EditTasksSuccess implements Action {
  readonly type = LeadsBoardActionTypes.EditTasksSuccess;
  constructor(public payload: TaskResponse, public isSocket?: boolean) { }
}

export class EditTasksFailure implements Action {
  readonly type = LeadsBoardActionTypes.EditTasksFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Multiple Tasks */
export class EditMultipleTasks implements Action {
  readonly type = LeadsBoardActionTypes.EditMultipleTasks;
  constructor(public payload: TaskResponse[]) { }
}

/** Change Task Status */
export class ChangeTaskStatus implements Action {
  readonly type = LeadsBoardActionTypes.ChangeTaskStatus;
  constructor(public payload: {taskId: string, request: TaskChangeStatusRequest}) {}
}

export class ChangeTaskStatusSuccess implements Action {
  readonly type = LeadsBoardActionTypes.ChangeTaskStatusSuccess;
  constructor(public payload: TaskResponse) { }
}

export class ChangeTaskStatusFailure implements Action {
  readonly type = LeadsBoardActionTypes.ChangeTaskStatusFailure;
  constructor(public payload: HttpErrorResponse) { }
}

export class ChangeTaskStatusCanceled implements Action {
  readonly type = LeadsBoardActionTypes.ChangeTaskStatusCanceled;
  constructor(public payload: TaskResponse) { }
}

/** Delete Task Success */
export class DeleteTasksSuccess implements Action {
  readonly type = LeadsBoardActionTypes.DeleteTasksSuccess;
  constructor(public payload: string) { }
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = LeadsBoardActionTypes.SetFilter;
  constructor(public payload: TaskBoardFilter) {}
}

export class UpdateFilter implements Action {
  readonly type = LeadsBoardActionTypes.UpdateFilter;
  constructor(public payload: TaskBoardRequest) {}
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = LeadsBoardActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = LeadsBoardActionTypes.SetInitialState;
}

export type LeadsBoardActions =
  | UploadLeads
  | UploadLeadsSuccess
  | UploadLeadsFailure
  | LoadTasks
  | LoadTasksSuccess
  | LoadTasksFailure
  | AddTasks
  | AddTasksSuccess
  | AddTasksFailure
  | EditTasks
  | EditTasksSuccess
  | EditTasksFailure
  | EditMultipleTasks
  | ChangeTaskStatus
  | ChangeTaskStatusSuccess
  | ChangeTaskStatusFailure
  | ChangeTaskStatusCanceled
  | DeleteTasksSuccess
  | SetFilter
  | UpdateFilter
  | ClearFilter
  | SetInitialState
  ;

